import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import CountryType from "../enums/CountryType";
import { Select } from "antd";
const CountrySelect = ({ value, placeholder = "Country", disabled = false, onChange }) => {
    return (_jsx(Select, { value: value, onChange: onChange, placeholder: placeholder, disabled: disabled, showSearch: {
            optionFilterProp: ['label']
        }, options: CountryType.selectOptionsArray() }));
};
export default CountrySelect;
